try {
  if (!sessionStorage.getItem('gms_landing')) {
    sessionStorage.setItem('gms_landing', location.pathname + location.search);
    sessionStorage.setItem('gms_referrer', document.referrer || 'direct');
    sessionStorage.setItem('gms_entered', new Date().toISOString());
  }
} catch (e) {}

function getProvenance() {
  const p = { '_entry_referrer': 'unavailable', '_entry_page': 'unavailable' };
  try {
    p['_entry_referrer'] = sessionStorage.getItem('gms_referrer') || document.referrer || 'direct';
    p['_entry_page'] = sessionStorage.getItem('gms_landing') || location.pathname;
    p['_entered_at'] = sessionStorage.getItem('gms_entered') || '';
    p['_automated'] = String(navigator.webdriver === true);
    p['_ua'] = navigator.userAgent.slice(0, 200);
  } catch (e) {}
  return p;
}

// Pricing and TPI data come from the worker; see gms-cf src/index.js
const GMS_WORKER = 'https://gms.hudsongraeme.workers.dev';
const gmsConfig = await fetch(GMS_WORKER + '/config').then(r => r.json()).catch((e) => {
  console.error('Pricing config fetch failed:', e);
  return null;
});
const pricingConfig = gmsConfig ? gmsConfig.pricingConfig : undefined;
const validTpi = gmsConfig ? gmsConfig.validTpi : {};
const GMS_MINIMUM_PRICE = gmsConfig ? gmsConfig.minimumPrice : 25;





// Product line specific pricing formulas (linear: Price = slope * length + intercept)
// Updated with 10% margin over actual July 2025 price list data


console.log('pricingConfig loaded:', typeof pricingConfig !== 'undefined' ? 'SUCCESS' : 'FAILED');

window.pricingConfig = pricingConfig;
window.getProvenance = getProvenance;
window.gmsMinimumPrice = GMS_MINIMUM_PRICE;
window.gmsPriceMultiplier = (window.gmsMarketMultiplier || 1) * (gmsConfig && gmsConfig.regionMultiplier ? gmsConfig.regionMultiplier : 1);

function gmsUnitPrice(productLine, lengthInFeet) {
  const pricing = pricingConfig[productLine] || pricingConfig['X-CELL-US M42'];
  const mult = window.gmsPriceMultiplier || 1;
  return Math.round(Math.max(GMS_MINIMUM_PRICE, Math.round((lengthInFeet * pricing.slope + pricing.intercept) * 100) / 100) * mult * 100) / 100;
}

function gmsTrack(name, props) {
  if (typeof window.gmsTrack === 'function') window.gmsTrack(name, props);
}

async function gmsCreateBladeVariant(payload) {
  const spec = { line: payload.productLine, width: payload.width, tpi: payload.tpi, unit: payload.unit, length: payload.length, qty: payload.quantity };
  gmsTrack('blade_create', spec);
  let response;
  try {
    response = await fetch(GMS_WORKER, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  } catch (e) {
    gmsTrack('blade_create_fail', Object.assign({ x: 'network: ' + e.message }, spec));
    throw e;
  }
  const result = await response.json();
  if (!response.ok || !result.success || !result.variantId) {
    const msg = result.message || result.error || gmsT('configurator.create_variant_failed_default');
    gmsTrack('blade_create_fail', Object.assign({ x: String(response.status) + ' ' + msg + ' ' + (result.details || []).join('; ') }, spec));
    throw new Error(msg);
  }
  gmsTrack('blade_create_ok', spec);
  return result.variantId;
}

function gmsAddBladeToCart(variantId, quantity, extraProps, sellingPlanId) {
  const item = {
    id: variantId,
    quantity: quantity,
    properties: Object.assign(getProvenance(), { '_line_url': window.location.pathname }, extraProps || {})
  };
  if (sellingPlanId) item.selling_plan = sellingPlanId;
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(item)
  }).then(function (r) {
    if (r.ok) gmsTrack('cart_add_ok', { qty: quantity, x: sellingPlanId ? 'subscription' : 'one-time' });
    else r.clone().text().then(function (t) { gmsTrack('cart_add_fail', { qty: quantity, x: r.status + ' ' + t.slice(0, 120) }); }).catch(function () {});
    return r;
  }, function (e) {
    gmsTrack('cart_add_fail', { qty: quantity, x: 'network: ' + e.message });
    throw e;
  });
}

const gmsSubscriptionPlans = (gmsConfig && gmsConfig.subscriptionPlans) || [];

function gmsFrequencyControl(container) {
  if (!container || !gmsSubscriptionPlans.length) return function () { return null; };
  let selected = null;
  const wrap = document.createElement('div');
  wrap.className = 'gms-frequency';
  wrap.innerHTML = '<label class="gms-frequency-label">' + gmsT('configurator.delivery_label') + '</label><div class="gms-pills" role="radiogroup"></div><p class="gms-frequency-note" style="display:none">' + gmsT('configurator.delivery_note') + '</p>';
  const options = wrap.querySelector('.gms-pills');
  const note = wrap.querySelector('.gms-frequency-note');
  const choices = [{ id: null, label: gmsT('configurator.delivery_one_time') }].concat(gmsSubscriptionPlans.map(function (p) { return { id: p.id, label: gmsT('configurator.delivery_every_days', { days: p.days }) }; }));
  choices.forEach(function (choice, i) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gms-pill' + (i === 0 ? ' active' : '');
    btn.setAttribute('role', 'radio');
    btn.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
    btn.textContent = choice.label;
    btn.addEventListener('click', function () {
      selected = choice.id;
      options.querySelectorAll('.gms-pill').forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-checked', 'false'); });
      btn.classList.add('active');
      btn.setAttribute('aria-checked', 'true');
      note.style.display = selected ? '' : 'none';
    });
    options.appendChild(btn);
  });
  container.parentNode.insertBefore(wrap, container);
  return function () { return selected; };
}
window.gmsFrequencyControl = gmsFrequencyControl;

const gmsShipping = (gmsConfig && gmsConfig.shipping) || null;

function gmsBladeWeightKg(width, length, unit) {
  const w = gmsShipping && gmsShipping.weight;
  if (!w) return 1;
  const m = String(width).match(/^(\d+(?:\.\d+)?)(?:x(\d+(?:\.\d+)?))?mm$/);
  if (!m) return 1;
  const widthMm = parseFloat(m[1]);
  const thicknessMm = m[2] ? parseFloat(m[2]) : (w.thicknessMm[Math.round(widthMm)] || 1.3);
  const lengthMm = unit === 'mm' ? length : unit === 'feet' ? length * 304.8 : length * 25.4;
  return Math.round((widthMm * thicknessMm * lengthMm * w.steelKgPerMm3 + w.packagingKg) * 100) / 100;
}

function gmsShippingQuote(weightKg) {
  if (!gmsShipping) return null;
  const pick = function (zone, name) {
    const r = zone.rates.filter(function (x) { return x.name === name && weightKg > x.minKg && weightKg <= x.maxKg; }).sort(function (a, b) { return a.price - b.price; })[0];
    return r ? r.price : null;
  };
  const zones = gmsShipping.zones.map(function (zone) {
    return { code: zone.code, label: zone.label, standard: pick(zone, 'Standard'), express: pick(zone, 'Express'), hasExpress: zone.rates.some(function (x) { return x.name === 'Express'; }) };
  });
  const local = zones.find(function (z) { return z.code === gmsShipping.country; });
  if (local) zones.splice(zones.indexOf(local), 1), zones.unshift(local);
  return { weightKg: weightKg, zones: zones, local: local ? local.code : '' };
}

const gmsZoneLabelKeys = { CA: 'configurator.zone_ca', US: 'configurator.zone_us' };
const gmsShipNouns = {
  blades: { one: 'configurator.ship_noun_blade_one', other: 'configurator.ship_noun_blade_other' },
  items: { one: 'configurator.ship_noun_item_one', other: 'configurator.ship_noun_item_other' }
};

function gmsRenderShipping(anchor, weightKg, count, noun) {
  if (!anchor || !gmsShipping) return;
  noun = noun || 'blades';
  const q = gmsShippingQuote(weightKg || 1);
  if (!q) return;
  let note = anchor.parentNode.querySelector('.gms-ship-note');
  if (!note) {
    note = document.createElement('div');
    note.className = 'gms-ship-note';
    anchor.parentNode.insertBefore(note, anchor.nextSibling);
  }
  const showExpress = q.zones.some(function (z) { return z.hasExpress; });
  const money = function (v) { return v === null ? gmsT('configurator.at_checkout') : gmsMoney(v); };
  let html = '<table class="gms-ship-table"><thead><tr><th>' + gmsT('configurator.ship_th_shipping') + '</th><th>' + gmsT('configurator.ship_th_standard') + '</th>' + (showExpress ? '<th>' + gmsT('configurator.ship_th_express') + '</th>' : '') + '</tr></thead><tbody>';
  q.zones.forEach(function (z) {
    const zoneLabelKey = gmsZoneLabelKeys[z.code];
    const zoneLabel = zoneLabelKey ? gmsT(zoneLabelKey) : z.label;
    html += '<tr' + (z.code === q.local ? ' class="local"' : '') + '><td>' + zoneLabel + '</td><td>' + money(z.standard) + '</td>' + (showExpress ? '<td>' + (z.hasExpress ? money(z.express) : '-') + '</td>' : '') + '</tr>';
  });
  html += '</tbody></table>';
  const nounForms = gmsShipNouns[noun];
  const nounSingular = nounForms ? gmsT(nounForms.one) : noun.replace(/s$/, '');
  const nounPlural = nounForms ? gmsT(nounForms.other) : noun;
  const what = !weightKg ? gmsT('configurator.ship_estimate_one', { noun: nounSingular }) : count > 1 ? gmsT('configurator.ship_count_note', { count: count, noun: nounPlural, weight: gmsNum(weightKg.toFixed(1)) }) : gmsT('configurator.ship_per_order', { weight: gmsNum(weightKg.toFixed(1)) });
  const verb = noun === 'blades' ? gmsT('configurator.ship_verb_welded') : gmsT('configurator.ship_verb_ships');
  html += '<p class="gms-ship-meta">' + gmsT('configurator.ship_meta', { what: what, verb: verb, days: (window.gmsLocale === 'fr' && gmsShipping.handlingDaysFr) || gmsShipping.handlingDays }) + '</p>';
  note.innerHTML = html;
}

window.gmsBladeWeightKg = gmsBladeWeightKg;
window.gmsShippingQuote = gmsShippingQuote;
window.gmsRenderShipping = gmsRenderShipping;
window.gmsUnitPrice = gmsUnitPrice;
window.gmsCreateBladeVariant = gmsCreateBladeVariant;
window.gmsAddBladeToCart = gmsAddBladeToCart;
document.dispatchEvent(new Event('gms:pricing-ready'));

// Hash generation is now handled by the backend

function detectProductLine() {
  if (window.gmsProductLine) {
    return window.gmsProductLine;
  }
  const currentUrl = window.location.href.toLowerCase();
  const pageTitle = document.title.toLowerCase();

  if (currentUrl.includes('black-line-tc') || pageTitle.includes('black-line tc')) {
    return 'Black Line TC';
  } else if (currentUrl.includes('sl-9') || pageTitle.includes('sl-9')) {
    return 'SL-9';
  } else if (currentUrl.includes('silver-line-n') || pageTitle.includes('silver line n')) {
    return 'Silver Line N';
  } else if (currentUrl.includes('silver-line') || pageTitle.includes('silver line')) {
    return 'Silver Line';
  } else if (currentUrl.includes('x-pro') || pageTitle.includes('x-pro')) {
    return 'X-Pro';
  } else if (currentUrl.includes('x-cell-pro') || pageTitle.includes('x-cell pro')) {
    return 'X-Cell Pro';
  } else if (currentUrl.includes('cs-1') || pageTitle.includes('cs-1')) {
    return 'CS-1';
  } else if (currentUrl.includes('sprint-pro') || pageTitle.includes('sprint pro')) {
    return 'Sprint Pro';
  } else if (currentUrl.includes('sprint-plus') || pageTitle.includes('sprint plus')) {
    return 'Sprint Plus';
  } else if (currentUrl.includes('black-line') || pageTitle.includes('black line')) {
    return 'Black Line S';
  } else if (currentUrl.includes('x-fit') || pageTitle.includes('x-fit')) {
    return 'X-FIT';
  }
  return 'X-CELL-US M42'; // Default
}

function updateTpiOptions() {
  const width = document.querySelector('#width').value;
  const tpiSelect = document.querySelector('#tpi');
  const map = Object.assign({}, validTpi, window.validTpi || {});
  const options = map[width];
  if (!options) return;
  tpiSelect.innerHTML = options.map(tpi => `<option value="${tpi}">${gmsT('configurator.tpi_option_label', { tpi: tpi })}</option>`).join('');
}

function validateLength(length, unit, showError = true, productLine = 'X-CELL-US M42') {
  const lengthInput = document.querySelector('#blade-length');
  const errorElement = document.querySelector('#length-error') || createLengthErrorElement();

  // Convert to feet for validation (using product line limits)
  let lengthInFeet;
  let lengthInMm;

  if (unit === 'inches') {
    lengthInFeet = length / 12; // inches to feet
    lengthInMm = length * 25.4; // inches to mm
  } else if (unit === 'feet') {
    lengthInFeet = length; // already in feet
    lengthInMm = length * 304.8; // feet to mm
  } else {
    lengthInFeet = length / 304.8; // mm to feet
    lengthInMm = length; // already in mm
  }

  // Get pricing config for current product line
  if (typeof pricingConfig === 'undefined') {
    console.error('pricingConfig is not defined in validateLength function');
    return { isValid: false, errorMessage: gmsT('configurator.config_error'), lengthInMm: 0 };
  }
  const pricing = pricingConfig[productLine] || pricingConfig['X-CELL-US M42'];
  const minLengthFt = pricing.minLength;
  const maxLengthFt = pricing.maxLength;

  let isValid = true;
  let errorMessage = '';

  if (isNaN(length) || length <= 0) {
    isValid = false;
    errorMessage = gmsT('configurator.length_invalid');
  } else if (lengthInFeet < minLengthFt) {
    isValid = false;
    if (unit === 'inches') {
      errorMessage = gmsT('configurator.length_min_inches', { value: minLengthFt * 12, ft: minLengthFt, line: productLine });
    } else if (unit === 'feet') {
      errorMessage = gmsT('configurator.length_min_feet', { value: minLengthFt, line: productLine });
    } else {
      errorMessage = gmsT('configurator.length_min_mm', { value: (minLengthFt * 304.8).toFixed(0), ft: minLengthFt, line: productLine });
    }
  } else if (lengthInFeet > maxLengthFt) {
    isValid = false;
    if (unit === 'inches') {
      errorMessage = gmsT('configurator.length_max_inches', { value: maxLengthFt * 12, ft: maxLengthFt, line: productLine });
    } else if (unit === 'feet') {
      errorMessage = gmsT('configurator.length_max_feet', { value: maxLengthFt, line: productLine });
    } else {
      errorMessage = gmsT('configurator.length_max_mm', { value: (maxLengthFt * 304.8).toFixed(0), ft: maxLengthFt, line: productLine });
    }
  }

  if (showError) {
    // Update visual feedback
    if (isValid) {
      lengthInput.style.borderColor = '';
      lengthInput.style.backgroundColor = '';
      errorElement.textContent = '';
      errorElement.style.display = 'none';
    } else {
      lengthInput.style.borderColor = '#dc3545';
      lengthInput.style.backgroundColor = '#fff5f5';
      lengthInput.style.borderWidth = '2px';
      errorElement.textContent = errorMessage;
      errorElement.style.display = 'block';
    }
  }

  return { isValid, errorMessage, lengthInMm };
}

function gmsClearLengthError() {
  const lengthInput = document.querySelector('#blade-length');
  const errorElement = document.querySelector('#length-error');
  if (lengthInput) {
    lengthInput.style.borderColor = '';
    lengthInput.style.backgroundColor = '';
  }
  if (errorElement) {
    errorElement.textContent = '';
    errorElement.style.display = 'none';
  }
}

function gmsUnitHint(length, unit, productLine) {
  const errorElement = document.querySelector('#length-error');
  const lengthInput = document.querySelector('#blade-length');
  if (!errorElement || !lengthInput || !(length > 0) || typeof pricingConfig === 'undefined') return;
  const pricing = pricingConfig[productLine] || pricingConfig['X-CELL-US M42'];
  const minIn = pricing.minLength * 12;
  const maxIn = pricing.maxLength * 12;
  let fix = null;
  if (unit === 'inches' && length < minIn && length * 12 >= minIn && length * 12 <= maxIn) {
    fix = { value: Math.round(length * 12 * 100) / 100, text: gmsT('configurator.hint_feet', { value: gmsNum(length), inches: gmsNum(Math.round(length * 12 * 100) / 100) }), btn: gmsT('configurator.hint_feet_btn', { inches: gmsNum(Math.round(length * 12 * 100) / 100) }) };
  } else if (unit === 'mm' && length < minIn * 25.4 && length * 25.4 >= minIn * 25.4 && length * 25.4 <= maxIn * 25.4) {
    fix = { value: Math.round(length * 25.4), text: gmsT('configurator.hint_inches', { value: gmsNum(length), mm: Math.round(length * 25.4) }), btn: gmsT('configurator.hint_inches_btn', { mm: Math.round(length * 25.4) }) };
  }
  if (!fix) return;
  const hint = document.createElement('div');
  hint.style.cssText = 'margin-top:6px;color:#333;font-weight:600;display:flex;flex-wrap:wrap;gap:8px;align-items:center;';
  const span = document.createElement('span');
  span.textContent = fix.text;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = fix.btn;
  btn.style.cssText = 'border:1px solid #111;background:#fff;color:#111;border-radius:6px;padding:5px 10px;font-size:12px;font-weight:800;cursor:pointer;';
  btn.addEventListener('click', function () {
    lengthInput.value = fix.value;
    gmsTrack('length_unit_fix', { x: unit, length: fix.value, unit: unit });
    calculatePrice();
  });
  hint.appendChild(span);
  hint.appendChild(btn);
  errorElement.appendChild(hint);
}

function createLengthErrorElement() {
  const lengthInput = document.querySelector('#blade-length');
  const errorElement = document.createElement('div');
  errorElement.id = 'length-error';
  errorElement.style.cssText = `
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
    display: none;
    font-weight: 500;
  `;
  lengthInput.parentNode.insertBefore(errorElement, lengthInput.nextSibling);
  return errorElement;
}

function calculatePrice() {
  const width = document.querySelector('#width').value;
  const tpi = document.querySelector('#tpi').value;
  const length = parseFloat(document.querySelector('#blade-length').value);
  const unit = document.querySelector('#length-unit').value;
  const quantity = parseInt(document.querySelector('#quantity').value);
  const priceElement = document.querySelector('#dynamic-price');

  // Check if this is initial page load (no user interaction yet)
  const lengthInput = document.querySelector('#blade-length');
  const isTyping = lengthInput.dataset.typing === '1';
  const hasUserInteracted = lengthInput.dataset.userInteracted === 'true' && !isTyping;
  if (isTyping) gmsClearLengthError();

  // Detect product line from page URL or title
  const productLine = detectProductLine();

  // Validate length with visual feedback only if user has interacted
  const lengthValidation = validateLength(length, unit, hasUserInteracted, productLine);

  if (!width || !tpi || isNaN(quantity) || quantity < 1 || quantity > 100) {
    priceElement.textContent = gmsT('configurator.select_valid_qty');
    return null;
  }

  if (isNaN(length) || !lengthValidation.isValid) {
    gmsRenderShipping(priceElement, 0, 1);
    if (hasUserInteracted && !lengthValidation.isValid) {
      priceElement.textContent = gmsT('configurator.invalid_length_price', { message: lengthValidation.errorMessage });
      gmsUnitHint(length, unit, productLine);
      gmsSpecInvalid({ line: productLine, width, tpi, unit, length: isNaN(length) ? 0 : length, x: lengthValidation.errorMessage });
    } else {
      priceElement.textContent = gmsT('configurator.enter_length');
    }
    return null;
  }

    // Convert length to feet
  const lengthInFeet = unit === 'inches' ? length / 12 :
                       unit === 'feet' ? length :
                       length / 304.8; // mm to feet

  // Get pricing config for current product line
  if (typeof pricingConfig === 'undefined') {
    console.error('pricingConfig is not defined in calculatePrice function');
    priceElement.textContent = gmsT('configurator.config_error');
    return null;
  }
  const pricing = pricingConfig[productLine] || pricingConfig['X-CELL-US M42'];

  // Check length limits for this product line
  if (lengthInFeet < pricing.minLength || lengthInFeet > pricing.maxLength) {
    priceElement.textContent = gmsT('configurator.length_range', { min: pricing.minLength, max: pricing.maxLength, line: productLine });
    return null;
  }

  const pricePerBlade = gmsUnitPrice(productLine, lengthInFeet);
  const totalPrice = pricePerBlade * quantity;

  console.log('Detected product line:', productLine, 'from URL:', window.location.href);

  // Get the current product ID from the page
  const baseProductId = getCurrentProductId();
  console.log('Current base product ID:', baseProductId);

  const cadNote = (window.gmsMarketMultiplier || 1) > 1 ? gmsT('configurator.cad_note') : '';
  const priceLineKey = quantity > 1 ? 'configurator.price_line_other' : 'configurator.price_line_one';
  priceElement.textContent = gmsT(priceLineKey, { total: gmsMoney(totalPrice), qty: quantity, unit: gmsMoney(pricePerBlade), cad: cadNote });
  gmsRenderShipping(priceElement, Math.round(gmsBladeWeightKg(width, length, unit) * quantity * 100) / 100, quantity);
  gmsPriceShown({ line: productLine, width, tpi, unit, length, qty: quantity, price: pricePerBlade });
  return {
    width,
    tpi,
    length,
    unit,
    quantity,
    productLine,
    baseProductId
    // pricePerBlade will be calculated by the backend
    // hash will be generated by the backend
  };
}

let gmsPriceTimer = null;
let gmsLastPriceKey = '';
function gmsPriceShown(spec) {
  const key = [spec.line, spec.width, spec.tpi, spec.unit, spec.length, spec.qty].join('|');
  if (key === gmsLastPriceKey) return;
  clearTimeout(gmsPriceTimer);
  gmsPriceTimer = setTimeout(function () { gmsLastPriceKey = key; gmsTrack('price_shown', spec); }, 900);
}
let gmsInvalidTimer = null;
function gmsSpecInvalid(spec) {
  clearTimeout(gmsInvalidTimer);
  gmsInvalidTimer = setTimeout(function () { gmsTrack('spec_invalid', spec); }, 1500);
}

function getCurrentProductId() {
  // Use the confirmed reliable methods from your Shopify theme

  // Primary: ShopifyAnalytics (most reliable)
  if (window.ShopifyAnalytics?.meta?.product?.id) {
    return window.ShopifyAnalytics.meta.product.id;
  }

  // Fallback: window.meta (secondary reliable)
  if (window.meta?.product?.id) {
    return window.meta.product.id;
  }

  return null;
}

document.querySelector('#width')?.addEventListener('change', () => {
  updateTpiOptions();
  calculatePrice();
});

let gmsLengthTypingTimer = null;
['#tpi', '#blade-length', '#length-unit', '#quantity'].forEach(selector => {
  const element = document.querySelector(selector);
  if (!element) return;
  if (selector === '#blade-length') {
    element.addEventListener('input', function () {
      this.dataset.userInteracted = 'true';
      this.dataset.typing = '1';
      clearTimeout(gmsLengthTypingTimer);
      gmsLengthTypingTimer = setTimeout(() => { delete this.dataset.typing; calculatePrice(); }, 900);
      calculatePrice();
    });
    element.addEventListener('blur', function () {
      this.dataset.userInteracted = 'true';
      clearTimeout(gmsLengthTypingTimer);
      delete this.dataset.typing;
      calculatePrice();
    });
    element.addEventListener('change', calculatePrice);
    return;
  }
  element.addEventListener('change', calculatePrice);
  element.addEventListener('input', calculatePrice);
});

// Add event listener for unit changes to re-validate length
document.querySelector('#length-unit')?.addEventListener('change', function() {
  const lengthInput = document.querySelector('#blade-length');
  if (lengthInput && lengthInput.dataset.userInteracted === 'true') {
    const length = parseFloat(lengthInput.value);
    if (!isNaN(length)) {
      calculatePrice();
    }
  }
});

document.querySelector('#add-to-cart-custom')?.addEventListener('click', async () => {
  // Force validation display for final check
  const lengthInput = document.querySelector('#blade-length');
  lengthInput.dataset.userInteracted = 'true';

  const data = calculatePrice();
  if (!data) {
    // Check if it's a length validation issue
    const length = parseFloat(lengthInput.value);
    const unit = document.querySelector('#length-unit').value;
    const lengthValidation = validateLength(length, unit, true);

    if (!lengthValidation.isValid) {
      alert(gmsT('configurator.fix_length_alert', { message: lengthValidation.errorMessage }));
    } else {
      alert(gmsT('configurator.select_all_alert'));
    }
    return;
  }

  const button = document.querySelector('#add-to-cart-custom');
  const originalText = button.textContent;
  button.textContent = gmsT('configurator.btn_processing');
  button.disabled = true;

  try {
    console.log('Sending product creation request:', data);

    const variantId = await gmsCreateBladeVariant(data);
    console.log(`Product created/found with variant ID: ${variantId}`);
    button.textContent = gmsT('configurator.btn_adding');

    const cartResponse = await gmsAddBladeToCart(variantId, data.quantity, null, window.gmsSelectedPlan ? window.gmsSelectedPlan() : null);

    if (cartResponse.ok) {
      console.log('Successfully added to cart');
      window.location.href = gmsUrl('/cart');
    } else {
      const errorText = await cartResponse.text();
      console.error('Cart add failed:', {
        status: cartResponse.status,
        statusText: cartResponse.statusText,
        body: errorText
      });

      let errorMessage = gmsT('configurator.cart_add_failed_default');
      try {
        const errorData = JSON.parse(errorText);
        errorMessage = errorData.message || errorData.description || errorMessage;
      } catch (e) {
        errorMessage = errorText || errorMessage;
      }

      alert(gmsT('configurator.cart_fail_alert', { message: errorMessage }));
      window.location.href = gmsUrl(`/cart/add?id=${variantId}&quantity=${data.quantity}`);
    }

  } catch (error) {
    console.error('Error:', error);
    alert(gmsT('configurator.error_retry_alert', { message: error.message }));
  } finally {
    button.textContent = originalText;
    button.disabled = false;
  }
});

// Add error handling for network issues
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

function applySpecFromUrl() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('length')) return;
  const widthSelect = document.querySelector('#width');
  const tpiSelect = document.querySelector('#tpi');
  const lengthInput = document.querySelector('#blade-length');
  const unitSelect = document.querySelector('#length-unit');
  const qtyInput = document.querySelector('#quantity');
  const width = params.get('width');
  if (width && widthSelect) {
    let match = [...widthSelect.options].find(o => o.value === width);
    if (!match) {
      const target = parseFloat(width);
      match = [...widthSelect.options].find(o => parseFloat(o.value) === target);
    }
    if (match) {
      widthSelect.value = match.value;
      widthSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  const length = parseFloat(params.get('length'));
  if (lengthInput && length > 0 && length <= 10000) {
    lengthInput.value = length;
    lengthInput.dataset.userInteracted = 'true';
  }
  const unit = params.get('unit');
  if (unit && unitSelect && [...unitSelect.options].some(o => o.value === unit)) {
    unitSelect.value = unit;
  }
  const qty = parseInt(params.get('qty'), 10);
  if (qtyInput && qty >= 1 && qty <= 100) {
    qtyInput.value = qty;
  }
  // TPI last: line tpi_map overrides rebuild the select shortly after load
  const tpi = params.get('tpi');
  if (tpi && tpiSelect) {
    setTimeout(() => {
      if ([...tpiSelect.options].some(o => o.value === tpi)) tpiSelect.value = tpi;
      calculatePrice();
    }, 120);
  }
  calculatePrice();
}

function initConfigurator() {
  if (!document.querySelector('#add-to-cart-custom')) return;
  console.log('Frontend initialized');
  updateTpiOptions();
  createLengthErrorElement();
  const lengthInput = document.querySelector('#blade-length');
  if (lengthInput) {
    lengthInput.dataset.userInteracted = 'false';
  }
  applySpecFromUrl();
  calculatePrice();
}
// Module execution is delayed by the config fetch, so DOMContentLoaded may already have fired
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initConfigurator);
} else {
  initConfigurator();
}
